import React from 'react'
import { Modal, Form, Input, Row, Col } from 'antd'

const MONTH_NAMES = [
  '',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const EventLockModal = Form.create({ name: 'event_lock_modal' })(
  ({
    visible,
    onCancel,
    onSave,
    form,
    unit,
    year,
    month,
    currentStatus,
    loading,
  }) => {
    const isLocking = currentStatus !== 'ML'
    const action = isLocking ? 'Lock' : 'Unlock'

    const handleOk = () => {
      form.validateFields((err, values) => {
        if (err) return
        onSave({
          status: isLocking ? 'ML' : 'MU',
          reason: values.reason,
        })
      })
    }

    const handleCancel = () => {
      form.resetFields()
      onCancel()
    }

    return (
      <Modal
        title={`Monthly ${action}`}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={action}
        confirmLoading={loading}
        destroyOnClose
      >
        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Unit">
                <Input value={unit} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Year">
                <Input value={year} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Month">
                <Input value={month ? MONTH_NAMES[month] : ''} disabled />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Reason">
            {form.getFieldDecorator('reason', {
              rules: [{ required: true, message: 'Reason is required' }],
            })(
              <Input.TextArea
                rows={4}
                maxLength={4000}
                placeholder={`Reason for monthly ${action.toLowerCase()}...`}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
)

export default EventLockModal
